import { render, staticRenderFns } from "./advices.html?vue&type=template&id=9e999016&external"
import script from "./advices.vue?vue&type=script&lang=js"
export * from "./advices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports